import Designer from "./components/designer";
import Header from "./components/header";
import GuidedTour from "./components/guidedTour";
import { useContext, useEffect, useRef, useState } from "react";
import didTextureScript from "./did/src/textures";
import didScript from "./did/src/3dinsert";
import { notify, readMaterials, saveMaterials } from "./util/helpers";
import { getDatabase, ref, child, get } from "firebase/database";
import axios from "axios";
import AppContext from "./context";
import Loader from "./components/loader";
import { db } from "./firebase";

function App() {
  const [loading, setLoading] = useState(true);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [showTour, setShowTour] = useState(false);
  const { triggerPriceUpdate, triggerDimensionsUpdate, handleSetMaterials } =
    useContext(AppContext);
  const designerRef = useRef(null);

  useEffect(() => {
    const fetchMaterials = async () => {
      return new Promise(async (resolve) => {
        try {
          const result = await axios.get("/.netlify/functions/store/materials");
          handleSetMaterials(result.data);
          sessionStorage.setItem("materials-stored", true);
          resolve(saveMaterials(result.data));
        } catch (error) {
          console.log(error.message);
          /*           setLoadingData(false); */
        }
      });
    };
    // moved loading Shopify materials here to prevent crashes regarding some UI elements not being loaded for the 3dinsert script
    // run onPageLoad function when the app mounts
    const onPageLoad = async () => {
      const materialsStoredStatus = sessionStorage.getItem("materials-stored");
      const materialsStored = await readMaterials();
      if (!materialsStoredStatus || materialsStored.materials.length === 0) {
        await fetchMaterials();
        await didTextureScript();
      } else {
        handleSetMaterials(materialsStored.materials);
        await didTextureScript();
      }
      didScript();
      setScriptLoaded(true);
      triggerPriceUpdate();
      triggerDimensionsUpdate();
      setLoading(false);
    };
    onPageLoad();
  }, []);

  useEffect(() => {
    if (scriptLoaded) {
      // check if there is url parameter called "shared_insert"
      const queryParams = new URLSearchParams(window?.location.search);
      const sharedInsertKey = queryParams.get("shared_insert");
      const autoSavedInsert = sessionStorage.getItem("autosaved_insert");
      if (sharedInsertKey) {
        const dbRef = ref(db);
        let sharedInsertData;
        get(child(dbRef, `shared/${sharedInsertKey}`))
          .then(async (snapshot) => {
            if (snapshot.exists()) {
              sharedInsertData = snapshot.val();
              const decompressed = await axios.post(
                "/.netlify/functions/insert/gunzip",
                snapshot.val()
              );
              window?.loadInsert?.(JSON.stringify(decompressed.data));
              notify("Shared insert loaded!");
              triggerPriceUpdate();
              triggerDimensionsUpdate();
            }
          })
          .catch((error) => {
            console.error(error);
          });
        setLoading(false);
      } else if (autoSavedInsert) {
        window?.loadInsert?.(autoSavedInsert);
        triggerPriceUpdate();
        triggerDimensionsUpdate();
        notify("Saved insert loaded!");
        setLoading(false);
      } else {
        triggerPriceUpdate();
        triggerDimensionsUpdate();
        setLoading(false);
      }

      // Show the guided tour once the app is fully loaded
      // Skip if there's a shared insert or if user has opted out
      const shouldShowTour = localStorage.getItem('skipDrawerInsertTour') !== 'true';
      if (shouldShowTour && !sharedInsertKey) {
        // Slight delay to ensure all elements are rendered
        setTimeout(() => {
          setShowTour(true);
        }, 1000);
      }
    }
  }, [scriptLoaded]);

  const handleCloseTour = () => {
    setShowTour(false);
  };

  return (
    <div className="did-app-container">
      <div id="notification-box">
        <div className="wrapper"></div>
      </div>
      <div className="did-app" ref={designerRef}>
        <Header />
        <Designer loading={loading} />
        {loading && <Loader />}
        {showTour && !loading && <GuidedTour onClose={handleCloseTour} />}
      </div>
    </div>
  );
}

export default App;
